import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: false,
  API_PREFIX: 'https://dev.api.denistiaglin.com',
  WEBSOCKET_PREFIX: 'wss://dev.api.denistiaglin.com',
  CABINET_PREFIX: 'https://dev.my.denistiaglin.com',
}
